import { useState, useEffect } from "react";
import { useLogExerciseMutation, useGetExercisesQuery } from "../../slices/coach/coachSlice";
import { Form, Button } from "react-bootstrap";
import AddExercise from "./AddExercise";
import Loader from "../Loader";

const toDatetimeLocal = (date = new Date()) => {
    return new Date(date - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16);
};

const ExerciseLog = (({ setShowExerciseLog }) => {
    const [type, setType] = useState('');
    const [duration, setDuration] = useState('');
    const [date, setDate] = useState(toDatetimeLocal());
    const [exerciseTypes, setExerciseTypes] = useState({});

    const [logExercise, { isLoading }] = useLogExerciseMutation();
    const { data } = useGetExercisesQuery();

    useEffect(() => {
        if (data) {
            const mapped = data.reduce((acc, { id, name }) => {
                acc[id] = name;
                return acc;
            }, {});
            setExerciseTypes(mapped);
        }
    }, [data]);

    const submitHandler = async (e) => {
        e.preventDefault();

        if (type === '' || duration === '') {
            window.alert('Please fill in type and duration');
            return;
        }

        try {
            await logExercise({
                duration,
                type,
                record_date: date,
            }).unwrap();
            window.alert("Exercise logged successfully!");
        } catch (error) {
            window.alert("Something went wrong");
            console.error(error?.data?.message || error.error);
        }

        setShowExerciseLog(false);
    }

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <h2 className='mt-3'>Log Exercise</h2>

                <Form onSubmit={submitHandler}>
                    <Form.Group controlId='type' className='my-1' style={{ maxWidth: '250px' }}>
                        <Form.Label>Type</Form.Label>
                        <Form.Select 
                            value={type}
                            onChange={(e) => setType(e.target.value)}>
                            <option value="">Select exercise type</option>
                            {Object.entries(exerciseTypes).map(([id, label]) => (
                            <option key={id} value={id}>{label}</option>))}
                        </Form.Select>
                    </Form.Group>

                    <AddExercise />

                    <Form.Group controlId='duration' className='my-1' style={{ maxWidth: '250px' }}>
                        <Form.Label>Duration (minutes)</Form.Label>
                        <Form.Control 
                            type='number'
                            placeholder='Minutes'
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}>
                        </Form.Control>

                    </Form.Group>

                    <Form.Group controlId='date-time' className='my-1' style={{ maxWidth: '250px' }}>
                        <Form.Label>Date & Time</Form.Label>
                        <Form.Control 
                            type='datetime-local'
                            value={date}
                            onChange={(e) => setDate(e.target.value)}>
                        </Form.Control>
                    </Form.Group>

                    <Button type='submit' className='quiz-btn-dark mt-2' disabled={isLoading}>
                        Log Exercise
                    </Button>
                    <Button onClick={() => setShowExerciseLog(false)} className='quiz-btn-dark mt-2' disabled={isLoading}>
                        Cancel
                    </Button>
                    { isLoading && <Loader />}
                </Form>
            </div>
        </div>
    )
});

export default ExerciseLog